import { z } from 'zod';

export const localeModelSchema = z.object({
  id: z.string(),
  type: z.literal('locale'),
  attributes: z.object({
    code: z.string(),
    name: z.string(),
    dateFormat: z.string(),
    timeFormat: z.string(),
  }),
});
